@if (!(isQuote$ | async) && part.isRushPart) {
  <div id="partCardFooter_div_IsNotQuote{{idSuffix}}" class="border-top p-2 d-flex justify-content-center">
    <a id="partCardFooter_a_NationalInventory{{idSuffix}}" role="button" class="hyperlink" href="javascript:void(0)" (click)="openNationalInventory(part)">National Inventory</a>
  </div>
}
